<template>
  <div
    id="content-rich-text">
    <v-divider></v-divider>

    <!-- Edit Form -->
    <form
      name="richTextContentItemForm"
      v-if="tab === 'edit'"
      @submit.prevent="updateContentItem('richTextItemUpdate')">
      <WYSIWYG
        class="page-tab-content-expand"
        v-model="contentItem.content">
      </WYSIWYG>

      <div class="page-buttons d-flex my-5">
        <v-btn
          type="submit"
          color="primary">
          Save
        </v-btn>

        <v-btn
          @click="goToContentList"
          type="button"
          color="primary"
          class="mr-auto order-first"
          outlined>
          Cancel
        </v-btn>
      </div>
    </form>
    <!-- / Edit Form -->

    <!-- Revisions -->
    <Revisions
      v-if="tab === 'revisions'"
    />
    <!-- / Revisions -->
  </div>
</template>

<script>
import WYSIWYG from './WYSIWYG/WYSIWYG.vue';
import ContentItemMixin from '../mixin.content-item';
import Revisions from './Revisions.vue';

export default {
  name: 'ContentRichText',
  props: ['tab'],
  mixins: [
    ContentItemMixin,
  ],
  components: {
    WYSIWYG,
    Revisions,
  },
};
</script>

<style lang="scss">
#content-rich-text {
  form[name="richTextContentItemForm"] {
    max-width: 900px;
  }
}
</style>
